<template>
  <div class="containerBox" ref="box">
    <!--  顶部导航  -->
    <nav-bar/>
    <!--  轮播图  -->
    <banner-list :banner-list="bannerList"/>
    <!--  新闻nav  -->
    <div class="newsNav" v-scroll-reveal>
      <div class="newsNav_item" @click="changeNav(4)">
        公司新闻
        <div v-if="articleType === 4" class="nav_border"></div>
      </div>
      <div class="nav_left"></div>
      <div class="newsNav_item" @click="changeNav(5)">
        行业新闻
        <div v-if="articleType === 5" class="nav_border"></div>
      </div>
      <div class="nav_left"></div>
      <div class="newsNav_item" @click="changeNav(6)">
        媒体报道
        <div v-if="articleType === 6" class="nav_border"></div>
      </div>
    </div>
    <!--  新闻列表  -->
    <div class="list container">
      <div class="list_item" v-for="(item, index) in list" :key="index" @click="goDetail(item.articleId)">
        <img class="news_img" :src="item.coverImgUrl" alt="">
        <div class="time">
          <p class="day">{{ item.createTime.substring(8, 10) }}</p>
          <p class="year">{{ item.createTime.substring(0, 7) }}</p>
        </div>
        <div class="content">
          <div class="content_title">{{ item.title }}</div>
          <div class="content_con">{{ item.intro }}</div>
        </div>
        <div class="news_icon">
          <img class="icon" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/news_icon.png"
               alt="">
          <img class="icon_a" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/news_icon_a.png"
               alt="">
        </div>
      </div>
    </div>
    <div style="margin: 70px 0">
      <el-pagination
          @current-change="changePage"
          background
          layout="prev, pager, next"
          :pager-count="pagerCount"
          :total="total">
      </el-pagination>
    </div>

    <!--  底部  -->
    <bottom-footer/>
    <!--  悬浮按钮  -->
    <fix-anchor @goBottom="goBottom"/>
  </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue';
import BannerList from '@/components/banner-list.vue';
import BottomFooter from '@/components/bottom-footer.vue';
import FixAnchor from '@/components/fix-anchor.vue';
import 'swiper/dist/js/swiper';
import 'swiper/dist/css/swiper.css';

export default {
  name: 'NewsList',
  components: {
    NavBar,
    BannerList,
    BottomFooter,
    FixAnchor,
  },
  data() {
    return {
      bannerList: [{coverImgUrl: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/news_banner.png'}],
      pagerCount: 5,
      pageNum: 1,
      articleType: 5, // 4：公司新闻； 5： 行业新闻； 6：媒体报道
      total: 0,
      list: [], // 新闻列表数据
    };
  },
  created() {
    // this.$public.getBanner(12, 0).then(res => {
    //   this.bannerList = this.bannerList.addAll(res.data.data.records)
    // });
    this.getList();
  },
  methods: {
    /**
     * @description: 跳转详情
     * @author: 书童
     */
    goDetail(id) {
      this.$router.push({
        path: '/newsdetail',
        query: {
          id
        }
      });
    },
    /**
     * @description: 切换新闻分类
     * @author: 书童
     */
    changeNav(num) {
      if (num === this.articleType) return;
      this.articleType = num;
      this.pageNum = 1;
      this.getList();
    },
    /**
     * @description: 切换页码
     * @author: 书童
     */
    changePage(e) {
      // console.log('按计划给大家看撒谎', e);
      this.pageNum = e;
      this.getList();
    },
    /**
     * @description: 获取新闻列表
     * @author: 书童
     * userType=4
     */
    getList() {
      this.$axios.get(`/public/appArticle/site/page?size=99&current=${this.pageNum}&articleType=${this.articleType}`).then(res => {
        if (res.data.code === 0) {
          this.list = res.data.data.records;
          this.total = res.data.data.total;
        }
      });
    },
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
     */
    goBottom() {
      let top = this.$refs.box.offsetHeight, scrollTop = document.documentElement.scrollTop,
          clientHeight = document.documentElement.clientHeight;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = scrollTop += 50;
        if (top <= (scrollTop + clientHeight)) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
  mounted() {
    if (this.$public.isMobile()) {
      window.location.href = 'http://hmmwuliu.net/common/ws-m/news.html';
    }
  }
};
</script>

<style scoped lang="scss">
.newsNav {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 176px;

  .newsNav_item {
    position: relative;
    height: 42px;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: LEFT;
    color: #333333;
    line-height: 42px;
    cursor: pointer;

    .nav_border {
      position: absolute;
      left: 0;
      bottom: -14px;
      width: 100%;
      height: 4px;
      background: #4E9BFF;
    }
  }

  .nav_left {
    width: 1px;
    height: 30px;
    background: #d9d9d9;
    margin: 0 50px;
  }

  .item_color {
    color: #4E9BFF;
  }
}

.list {
  .list_item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 1200px;
    height: 280px;
    padding: 50px 50px 40px 50px;
    box-sizing: border-box;
    cursor: pointer;

    .news_img {
      display: block;
      width: 340px;
      height: 172px;
      margin-top: 9px;
    }

    .time {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 100px;
      border: 2px solid #d9d9d9;
      box-sizing: border-box;
      margin-left: 60px;
      margin-right: 30px;
      margin-top: 10px;

      .day {
        font-size: 30px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 45px;
      }

      .year {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 27px;
      }
    }

    .content {
      width: 450px;
      height: 100%;
      margin-right: 80px;

      .content_title {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #555555;
        line-height: 30px;
        margin-top: 10px;
      }

      .content_con {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #555555;
        line-height: 21px;
        margin-top: 20px;
      }
    }

    .news_icon {
      width: 60px;
      height: 60px;
      margin-top: 60px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .icon_a {
        display: none;
      }
    }

  }

  .list_item:hover {
    box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.05);

    .news_icon {
      .icon {
        display: none;
      }

      .icon_a {
        display: block;
      }
    }
  }
}
</style>